(function(){
  if(window.__bmhQuickAdd) return; window.__bmhQuickAdd=true;
  let tt;
  const say=(m)=>{const t=document.querySelector('[data-bmc-toast]');if(!t)return;t.textContent=m;t.classList.add('is-on');clearTimeout(tt);tt=setTimeout(()=>t.classList.remove('is-on'),2600)};
  document.addEventListener('click',async e=>{
    const b=e.target.closest('[data-bh-rail] [data-bmc-add], [data-bmh-rail] [data-bmc-add]'); if(!b) return;
    e.preventDefault(); b.setAttribute('aria-busy','true');
    try{
      const r=await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[{id:Number(b.dataset.bmcAdd),quantity:1}]})});
      const j=await r.json();
      if(!r.ok||j.status){say(j.description||j.message||'Could not add to cart');return}
      const txt=b.textContent;b.classList.add('is-done');b.textContent='✓';setTimeout(()=>{b.classList.remove('is-done');b.textContent=txt},1800);
      const d=document.querySelector('cart-drawer');
      if(d&&typeof d.reload==='function'){d.reload();setTimeout(()=>{d.classList.remove('is-empty');!(window.bmApp&&window.bmApp.mobile())&&d.open&&d.open(b)},350)}else{say((window.bmT&&bmT.added)||'Added to cart')}
    }catch(err){say((window.bmT&&bmT.fail)||'Could not add to cart')}finally{b.removeAttribute('aria-busy')}
  });
})();
(function(){
  if(window.__bmhTabs) return; window.__bmhTabs=true;
  document.addEventListener('click',async e=>{
    const t=e.target.closest('[data-bmh-tab]'); if(!t||e.metaKey||e.ctrlKey||e.shiftKey) return;
    const rail=t.closest('[data-bmh-rail]'); if(!rail) return;
    e.preventDefault(); if(t.classList.contains('is-on')) return;
    const list=rail.querySelector('[data-bmh-list]'); const limit=Number(list.dataset.limit)||6;
    rail.querySelectorAll('[data-bmh-tab]').forEach(x=>{const on=x===t;x.classList.toggle('is-on',on);x.setAttribute('aria-selected',on)});
    list.style.opacity='.4';
    try{
      const html=await (await fetch(t.dataset.bmhTab+(t.dataset.bmhTab.includes('?')?'&':'?')+'section_id=brickmak-rail-items')).text();
      const doc=new DOMParser().parseFromString(html,'text/html');
      const items=[...doc.querySelectorAll('[data-bmh-items] > li')].slice(0,limit);
      if(items.length){list.replaceChildren(...items.map(li=>document.adoptNode(li)))}
      else{list.innerHTML='<li class="bmh-rail__empty">Nothing in stock here right now.</li>'}
      const all=rail.querySelector('[data-bmh-all]'); if(all) all.href=t.dataset.bmhTab;
    }catch(err){window.location=t.href}
    finally{list.style.opacity=''}
  });
})();
